﻿/* global kendo */
export function parseKendoDate(input) {
    let date = kendo.parseDate(input.val(), "MM/dd/yyyy");
    if (date) return date;

    date = kendo.parseDate(input.val(), "MM-dd-yyyy");
    if (date) return date;

    return input.data("kendoDatePicker").value();
}